module.exports = __webpack_public_path__ + "static/media/Rotated tooth14.d939dcee.png";